<template>
    <v-app class="app black--text" v-scroll="handleScroll">
        <div>
            <transition name="fade">
                <div
                        v-if="drawer"
                        class="drawer white"
                        @click=" drawer = !drawer, isActive = !isActive "
                >
                    <nav class="drawer__menu">
                        <ul>
                            <li v-for="link in links"
                                :key="link.title">
                                <router-link
                                        :to="{hash: link.hash, query: link.query}"
                                        tag="a"
                                        class="black--text"
                                        active-class="greyDark--text"
                                >{{ link.title }}
                                </router-link>
                            </li>
                        </ul>
                    </nav>
                </div>
            </transition>
            <header class="header"
                    v-bind:class="{ hidden: !isActive, top: headerTop }">
                <nav class="header__lang black--text">
                    <ul class="black--text">
                        <li :class="lang == 'ru' ? 'active' : ''"><a href="/">ru</a></li>
                        <li :class="lang == 'en' ? 'active' : ''"><a href="/en">eng</a></li>
                        <li :class="lang == 'fr' ? 'active' : ''"><a href="/fr">fr</a></li>
                    </ul>
                </nav>
                <nav class="navigation">
                    <ul>
                        <li v-for="link in links"
                            :key="link.title">
                            <router-link
                                    :to="{hash: link.hash, query: link.query, path: '/'}"
                                    tag="a"
                                    class="black--text"
                                    active-class="greyDark--text"
                            >{{ link.title }}
                            </router-link>
                        </li>
                    </ul>
                </nav>
            </header>
            <button
                    @click="(isActive = !isActive, drawer = !drawer)"
                    class="btn-menu black--text"
                    v-bind:class="{active: isActive, hidden: !btnHidden}"
            ></button>
            <router-view/>
        </div>
    </v-app>
</template>

<script>
    import HomePage from '@/components/HomePage'
    import axios from 'axios'

    export default {
        data() {
            return {
                btnHidden: false,
                headerTop: true,
                isActive: false,
                drawer: false,
                links: []
            }
        },
        components: {
            HomePage
        },
        methods: {
            handleScroll: function (evt, el) {
                if (window.scrollY > 50) {
                    this.isActive = false;
                    this.drawer = false;
                    this.headerTop = false;
                    this.btnHidden = true;
                } else {
                    this.headerTop = true;
                    this.btnHidden = false;
                }
            }
        },
        computed: {
            lang () {
                if (!this.$route.params.lang) {
                    return 'ru'
                }

                return this.$route.params.lang
            }
        },
        created() {
            let dataURL = this.$apiHost + "/api/v1/resources"

            if (this.$route.params.lang !== null && this.$route.params.lang !== undefined) {
                dataURL += '?lang=' + this.$route.params.lang
            }

            axios
                .get(dataURL, {
                    headers: {
                        'Accept': 'application/json',
                        'Content-type': 'application/json',
                        'Cache-control': 'no-cache'
                    }
                })
                .then(response => {
                    let resources = {}
                    for(let i = 0; i < response.data.length; i++) {
                        let item = response.data[i]

                        let link = {
                            title: item.menu_title,
                            hash: "#" + item.slug,
                        }

                        resources[item.slug] = item
                        this.links.push(link)
                    }

                    this.$store.commit('setResources', resources)
                    this.$eventHub.$emit('resourcesUploaded', resources);
                })
                .catch(error => {
                    console.warn(error)
                })
        }
    }

</script>

<style lang="scss">

    /* общие стили */

    @font-face {
        font-family: "CirceRegular";
        font-weight: 300;
        src: url('../src/assets/fonts/Circe-Regular.woff');
    }

    @font-face {
        font-family: "CirceLight";
        src: url('../src/assets/fonts/Circe-Light.woff');
    }

    @font-face {
        font-family: "CirceBold";
        src: url('../src/assets/fonts/Circe-Bold.woff');
    }

    @font-face {
        font-family: "CirceExtraBold";
        src: url('../src/assets/fonts/Circe-ExtraBold.woff');
    }

    .app {
        font-family: "CirceRegular", sans-serif;
        background: linear-gradient(#fdfdfd, #e6e6e6) !important;
    }

    .section {
        position: relative;
        width: 100%;
        height: 100vh;
        @media screen and (max-width: 1024px) {
            height: 100%;
        }
    }

    .clear {
        content: '';
        clear: both;
        display: block;
    }

    .section__title {
        margin-left: 10%;
        padding-top: 124px;
        text-transform: uppercase;
        font-family: "CirceBold", sans-serif;
        font-size: 24px;

    }

    .container {
        padding: 0;
        max-width: 80% !important;
    }

    .container-fluid {
        max-width: 1920px;
        margin: 0 auto;
        box-sizing: border-box;
        /*  border: 1px solid red;*/
    }

    .btn_content {
        width: 220px;
        height: 60px;
        line-height: 60px;
        font-size: 20px;
        text-transform: uppercase;
        outline: none;
        text-align: center;
        border: 2px solid #000;
        transition: .3s;
        font-family: "CirceBold", sans-serif;
    }

    .btn_content:hover {
        background: #000;
        color: white;
        border: 2px solid #000;
    }

    /* стили header-а* и меню */

    .header {
        position: fixed;
        height: 160px;
        padding-left: 7%;
        padding-right: 10%;
        top: 0;
        left: 0;
        right: 0;
        width: 100%;
        opacity: 1;
        display: flex;
        align-items: center;
        box-shadow: none !important;
        z-index: 100;
        transition: .2s;
        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
        background-color: rgb(156, 156, 156);
        @media screen and (max-width: 1400px) {
            padding-left: 5%;
        }
        @media screen and (max-width: 1024px) {
            height: 80px;
            background-color: #fff;
        }
    }

    .header.hidden {
        transition: .2s;
        background: transparent;
        z-index: -1;
        opacity: 0;
        @media screen and (max-width: 1024px) {
            background: white;
        }

    }

    .header.hidden.top {
        transition: .2s;
        opacity: 1;
        background: transparent;
        text-shadow: none;
        z-index: 100;
        @media screen and (max-width: 1024px) {
            background: white;
        }
    }

    .navigation {
        margin: 0 auto;
        @media screen and (max-width: 1400px) {
            margin-right: 5%;
        }
        @media screen and (max-width: 1024px) {
            display: none;
        }
    }

    .navigation ul {
        list-style-type: none;
        padding: 0;
        text-transform: uppercase;
    }

    .navigation ul li {
        font-family: "CirceBold", sans-serif;
        display: inline-block;
        margin: 0 15px;
        padding: 0;
        color: #000;
        font-size: 18px;
        @media screen and (max-width: 1400px) {
            margin: 0 10px;
            font-size: 16px;
        }

    }

    .navigation ul li:last-child {
        margin-right: 0;
    }

    .navigation ul li .router-link-active {
        color: grey;
    }

    .navigation ul li a {
        text-decoration: none;
    }

    .header__lang {
        margin-right: 30px;
    }

    .header__lang ul {
        list-style-type: none;
        color: inherit;
        outline: none;
        padding: 0;
        margin: 0;
    }

    .header__lang ul li {
        display: inline-block;
        text-transform: uppercase;
        color: #000;
        margin: 0 5px;
        font-size: 18px;
        font-family: "CirceExtraBold", sans-serif;
    }

    .header__lang ul li.active {
        color: #757575;
    }

    .header__lang ul li:first-child {
        margin-left: 0;
    }

    .header__lang ul li:last-child {
        margin-right: 0;
    }

    .header__lang ul li a {
        text-decoration: none;
        color: inherit;
    }

    .btn-menu {
        position: fixed;
        text-indent: -999em;
        overflow: hidden;
        display: block;
        width: 58px;
        height: 25px;
        right: 100px;
        outline: none;
        color: #000;
        transition: .3s;
        z-index: 99;
        background: linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 46%, #000 46%, #000 54%, rgba(0, 0, 0, 0) 54%, rgba(0, 0, 0, 0) 100%);
        top: 60px;

        &:after,
        &:before {
            transition: all ease-in-out 500ms;
            position: absolute;
            content: 'a';
            background-color: #000;
            height: 3px;
            width: 58px;
        }

        &:before {
            top: 3px;
            right: 0;
        }

        &:after {
            bottom: 3px;
            right: 0;
        }

        // Active
        &.active {
            z-index: 100;
            top: 55px;
            background: transparent;
            height: 45px;
            width: 45px;
            transition: background 1s !important;
            @media screen and (max-width: 1024px) {
                top: 20px;
            }

            &:after,
            &:before {
                top: 50%;
                background-color: #000;
                width: 50px;
            }

            &:before {
                transform: rotate(45deg);
                transform-origin: 50%;
            }

            &:after {
                transform: rotate(-45deg);
                transform-origin: 50%;
            }
        }

        @media screen and (max-width: 1024px) {
            right: 15px;
            top: 30px;
        }
    }

    .btn-menu.hidden {
        opacity: 0;
        z-index: -1;
        transition: .3s;
    }

    .drawer {
        display: none;
        @media screen and (max-width: 1024px) {
            display: flex;
            justify-content: center;
            align-items: center;
            position: fixed;
            top: 80px;
            bottom: 0;
            right: 0;
            left: 0;
            width: 100%;
            z-index: 999;
        }

    }

    .drawer__menu ul {
        list-style-type: none;
        padding: 0;
        margin-top: -73px;
        text-align: center;
    }

    .drawer__menu ul li {
        font-size: 22px;
        text-transform: uppercase;
        font-family: "CirceBold", sans-serif;
        margin-top: 5%;
        transition: .3s;

    }

    .drawer__menu ul li:hover a {
        color: #757575;

    }

    .drawer__menu ul li a {
        text-decoration: none;
    }

    /* стили "footer-а" */

    .footer {
        position: relative;
        width: 100%;
        height: 356px !important;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #e6e6e6;
        @media screen and (max-width: 1024px) {
            min-height: 356px;
        }
    }

    .footer__copy {
        font-size: 20px;
    }

    /* стили анимации модальных окон */

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    /* стили модального окна и его анимации */

    .modal {
        position: fixed;
        z-index: 99999;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(115, 115, 115, 0.89);
        transition: all .3s ease;
        display: flex;
        justify-content: center;
        align-items: center;
        @media screen and (max-width: 1024px) {
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
        }
    }

    .modal__window {
        transition: all .3s ease;
        width: 100%;
        max-width: 90%;
        background-color: transparent;
        color: black;
        max-height: 90%;
        overflow-y: auto;
        text-align: center;
        @media screen and (max-width: 610px) {
            max-width: 90%;
        }
        @media screen and (max-width: 400px) {
            max-height: 70%;
        }
    }

    .modal__window_video {
        position: relative;
        padding-bottom: 30%;
        padding-top: 15%;
        height: 0;
        @media screen and (max-width: 1024px) {
            padding-bottom: 50%;
        }
    }

    .modal__window_video iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .close_modal {
        position: absolute;
        top: 5px;
        right: 20px;
        outline: none;
        z-index: 99999;
        cursor: pointer;
        width: 40px;
        height: 40px;
        opacity: .66;
        transition: .3s;
    }

    .close_modal:hover {
        opacity: 1;
        transform: scale(1.03);
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal__window,
    .modal-leave-active .modal__window {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

</style>



// WEBPACK FOOTER //
// src/App.vue